import React, { useState, useEffect } from "react";
import { Input, Button, Form, Checkbox, message } from "antd";
import { useNavigate } from "react-router-dom";
import VerifyCodeBtn from "@/components/VerifyCodeBtn";

import { loginUrl } from "@/utils/base";
import { passwordReg, phoneReg } from "@/utils/constant";
import api from "@/api";
import dataJson from "@/../public/data.json";
import { hmacSHA256 } from "@/utils";
import PrivacyModel, { useModal } from "@/components/GetAccount/components/privacyModel";

import "./index.less";

const prefix = "getAccount";
const INPUT_HEIGHT = 46;

type Props = {
  type: string;
};
const GetAccount: React.FC<Props> = (props: Props) => {
  const { type } = props;
  const { account, and, confirmText, req_err } = dataJson;

  const [codeData, setCodeData] = useState<any>();
  const [isPhoneValueOk, setIsPhoneValueOk] = useState(false);

  const navigate = useNavigate();

  const contantObj: any = {
    registerAccount: {
      title: account.register_account,
      tip: account.register_account_tip,
      labelText: account.password,
      btnText: account.register,
      apiCode: api.getCodeRegister,
      apiFinish: api.userRegister,
      // beforeClick: async (cb: any) => {
      //   const resp: any = await api.checkPhone({ receiver: phoneValue });
      //   if (resp.code === 200 && resp.data === true) {
      //     window.message.error("该手机号已注册");
      //   } else {
      //     cb();
      //   }
      // },
    },
    forgotPassword: {
      title: account.forgot_password,
      tip: account.forgot_password_tip,
      labelText: account.new_password,
      btnText: confirmText,
      apiCode: api.getCodeForgot,
      apiFinish: api.userResetPassword,
      // beforeClick: async (cb: any) => {
      //   const resp: any = await api.checkPhone({ receiver: phoneValue });
      //   if (resp.code === 200 && resp.data === false) {
      //     window.message.error("该手机号未注册");
      //   } else {
      //     cb();
      //   }
      // },
    },
  };

  const passwordChange = () => {
    const confirmValue = form.getFieldValue("confirm");
    if (confirmValue) {
      form.validateFields(["confirm"]);
    }
  };

  const contantData = contantObj[type];

  const [form] = Form.useForm();
  const phoneValue = Form.useWatch("receiver", form);

  const onFinish = async (values: any) => {
    const res: any = await contantData.apiFinish({
      receiver: phoneValue,
      password: values?.password,
      validate: {
        code: values?.code,
        type: codeData?.type,
        function: codeData?.function,
        token: hmacSHA256(codeData?.token, codeData?.secret),
      },
    });
    const { code, msg } = res;

    if (code === 200) {
      navigate(loginUrl);
    } else {
      window.message.error(msg || req_err);
      
    }
  };

  // 验证失败
  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const setCode = (params: any) => {
    setCodeData(params);
  };

  const { isShowContract, fileType, viewContract, setIsShowContract } = useModal();

  useEffect(() => {
    phoneValue &&
      form.validateFields(["receiver"]).then(
        () => {
          setIsPhoneValueOk(true);
        },
        () => {
          setIsPhoneValueOk(false);
        }
      );
  }, [phoneValue]);
  useEffect(() => {
    console.log(211, form.getFieldsValue());
  }, []);

  return (
    <div className={prefix}>
      <div className={`${prefix}-title`}>{contantData.title}</div>
      <div className={`${prefix}-tip`}>{contantData.tip}</div>
      <Form
        className={`${prefix}-form`}
        form={form}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        colon={false}
      >
        <Form.Item
          label={account.phone_number}
          name="receiver"
          rules={[
            { required: true, message: account.phone_number_message },
            {
              pattern: phoneReg,
              message: account.phone_number_message,
            },
          ]}
        >
          <Input
            size="large"
            placeholder={account.phone_number_placeholder}
            style={{ height: INPUT_HEIGHT }}
          />
        </Form.Item>
        <div className={`${prefix}-code`}>
          <Form.Item
            label={account.code}
            name="code"
            rules={[{ required: true, message: account.code_message }]}
            style={{ margin: "0 16px 0 0" }}
          >
            <Input
              size="large"
              placeholder={account.code_placeholder}
              style={{ width: 216, height: INPUT_HEIGHT }}
            />
          </Form.Item>
          <VerifyCodeBtn
            phoneNumber={isPhoneValueOk ? phoneValue : ""}
            apiFnc={contantData.apiCode}
            height={INPUT_HEIGHT}
            reload={setCode}
            beforeClick={true}
          />
        </div>
        <Form.Item
          label={contantData.labelText}
          name="password"
          rules={[
            { required: true, message: account.new_password_message },
            {
              pattern: passwordReg,
              message: account.password_validate,
            },
          ]}
        >
          <Input.Password
            size="large"
            autoComplete="new-password"
            placeholder={account.new_password_placeholder}
            onChange={passwordChange}
            style={{ height: INPUT_HEIGHT }}
          />
        </Form.Item>
        <Form.Item
          label={account.confirm_password}
          name="confirm"
          rules={[
            { required: true, message: account.confirm_password_message },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(account.confirm_password_err));
              },
            }),
          ]}
        >
          <Input.Password
            size="large"
            placeholder={account.confirm_password_placeholder}
            style={{ height: INPUT_HEIGHT }}
          />
        </Form.Item>

        <Form.Item
          name="agree"
          valuePropName="checked"
          rules={[
            {
              validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error(account.check_agreement))),
            },
          ]}
          style={{ marginLeft: 80 }}
        >
          <Checkbox>
            {account.read_accepted}
            <Button
              type="link"
              style={{ padding: "0 2px", height: "19px" }}
              onClick={() => viewContract("privacy")}
            >
              {account.privacy_olicy}
            </Button>
            {and}
            <Button
              type="link"
              style={{ padding: "0 2px", height: "19px" }}
              onClick={() => viewContract("user")}
            >
              {account.user_agreement}
            </Button>
          </Checkbox>
        </Form.Item>

        <Form.Item style={{ textAlign: "center" }}>
          <Button type="primary" size="large" htmlType="submit" style={{ height: INPUT_HEIGHT, width: 120 }}>
            {contantData.btnText}
          </Button>
        </Form.Item>
      </Form>
      <PrivacyModel
        fileType={fileType}
        open={isShowContract}
        onOk={() => {
          setIsShowContract(false);
        }}
        onCancel={() => {
          setIsShowContract(false);
        }}
      />
    </div>
  );
};

export default GetAccount;
